export default __webpack_public_path__ + "static/media/Image4Tablet.6ec67e70.png";